<template>
  <div
    v-cloak
    v-html="html_content"
  />
</template>

<script>
import store from '../store';

export default {
  props: {
    lang: {
      type: String,
      default: store.getters['auth/user'].locale || 'th',
    },
    objectId: {
      type: Number,
      default: null,
    },
    objectSlug: {
      type: String,
      default: '',
    },
    objectType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      html_content: '',
    };
  },
  created() {
    if (!_.isEmpty(this.objectSlug)) {
      // eslint-disable-next-line no-undef
      $.get(`${blogUrl}/wp-json/verblick/v1/${this.objectType}/${this.objectSlug}?lang=${this.lang}`, (data) => {
        this.html_content = data;
      });
    } else {
      // eslint-disable-next-line no-undef
      $.get(`${blogUrl}/wp-json/verblick/v1/${this.objectType}/${this.objectId}?lang=${this.lang}`, (data) => {
        this.html_content = data;
      });
    }
  },
};
</script>
